import { ConfigProvider, theme } from "antd";
import { Route, Routes } from "react-router";
import AppLayout from "AppLayout";
import { defaultSettings } from "css/defaultAntStyles";
import { NotificationWrapper } from "Components/MyNotification/NotificationWrapper";
import ukUA from "antd/locale/uk_UA";
import { FullLoaderPage } from "Components/MyLoader/MyLoader";
import {
  privateRoutes,
  ProtectedRoute,
  publicRoutes,
  RoleGuard,
  telegramRoutes,
} from "Routes/routes";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllRolesThunk,
  refreshUserThunk,
  selectUser,
} from "AppStore/Slices/UserSlice/UserSlice";
import { useEffect } from "react";
import { getAllStatusesThunk } from "AppStore/Slices/ProjectSlice/ProjectSlice";

export default function App() {
  const isDark = defaultSettings.navTheme === "realDark";
  const { isAuth, roles, isRefreshing } = useSelector(selectUser);
  // const { isLoading } = useSelector(selectMainState);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isAuth) {
      dispatch(getAllRolesThunk());
      dispatch(getAllStatusesThunk());
    }
  }, [isAuth]);

  useEffect(() => {
    const fetchRefresh = async () => {
      dispatch(refreshUserThunk());
    };
    fetchRefresh();
  }, []);

  // if (isRefreshing && isLoading) {
  //   return <FullLoaderPage />;
  // }
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: defaultSettings.colorPrimary,
        },
        algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
      }}
      locale={ukUA}
    >
      <Routes>
        {publicRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}

        {/* <Route path="*" element={<Navigate to="/user/login" replace />} /> */}
        {telegramRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}

        <Route
          path="/"
          element={
            <ProtectedRoute isAuth={isAuth}>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          {privateRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={
                <RoleGuard rolesAccessArray={route.roles} userRoles={roles}>
                  {route.element}
                </RoleGuard>
              }
            />
          ))}

          {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
        </Route>
      </Routes>

      <NotificationWrapper />
      <FullLoaderPage />
    </ConfigProvider>
  );
}
